import { Form, TimePicker } from 'antd';

export function InputTime({ name = '', label = '', format = 'HH:mm:ss', required = false, onChange, inputProps }) {
  return (
    <Form.Item name={name} label={label} rules={[{ required, message: `กรุณาเลือก${label}` }]}>
      <TimePicker
        style={{ width: '100%' }}
        placeholder={`เลือก${label}`}
        onChange={onChange}
        format={format}
        {...inputProps}
      />
    </Form.Item>
  );
}
